































































































import { Component, Prop, Vue } from "vue-property-decorator";
// components
import vSelect from "vue-select";
// service methods
import { getStages, getFilters } from "@/services/stages/stageService";
// types
import { Stage, Filter } from "@/services/stages/types";
import { stagesFields } from "@/components/stages/fields/stagesFields";
import { Option } from "@/services/common/types";

@Component({
    components: {
        vSelect
    }
})
export default class SelectChannelModal extends Vue {
    @Prop() id!: string;
    // @Prop({ default: "" }) private instance!: string;
    // local state
    stages = [] as Array<Stage>;
    fields = stagesFields;
    isBusy = false;

    // filter
    filterWidth = "" as string;
    filterHeight = "" as string;
    solutions = [] as Array<Option>;
    designs = [] as Array<Option>;
    selectedSolution = null as Option | any;
    selectedDesign = null as Option | any;

    // filter options
    searchText = "" as string;
    selectedStages = [] as Stage[];
    multiPicker = false;

    open(multiPicker = false) {
        this.multiPicker = multiPicker;
        this.resetState();
        this.fetchData();
        this.$bvModal.show(this.id);
    }

    rowSelected(items: Stage[]) {
        this.selectedStages = items;
    }

    save() {
        if (this.multiPicker) {
            this.$emit("select", this.selectedStages.map(x => {
                return {
                    id: x.id,
                    name: x.name
                };
            }));
        } else {
            if (this.selectedStages.length > 0) {
                this.$emit("select", {
                    id: this.selectedStages[0].id,
                    name: this.selectedStages[0].name
                });
            }
        }
        this.$bvModal.hide(this.id);
    }

    fetchData() {
        this.loadStages();
        this.getFilters();
    }

    loadStages() {
        this.isBusy = true;
        this.stages = [] as Array<Stage>;
        const filter = { solutionId: this.selectedSolution ? this.selectedSolution.id : null, designId: this.selectedDesign ? this.selectedDesign.id : null } as Filter;
        getStages(filter).then(response => {
            this.stages = response;
            this.isBusy = false;
        });
    }

    clearFilter() {
        this.filterWidth = "";
        this.filterHeight = "";
        this.selectedSolution = null;
        this.selectedDesign = null;
        this.loadStages();
    }

    resetState() {
        this.searchText = "";
        this.filterWidth = "";
        this.filterHeight = "";
        this.selectedSolution = null;
        this.selectedDesign = null;
    }

    getFilters() {
        getFilters().then(response => {
            this.solutions = response.solutions.map(x => ({ id: x.id, text: x.name }));
            this.designs = response.designs.map(x => ({ id: x.id, text: x.name }));
        });
    }

    // computed and watchers
    get model(): Array<Stage> {
        return this.stages.filter(
            x => (this.searchText === "" ? true : x.name.toLowerCase().includes(this.searchText.toLowerCase())) &&
                (this.filterWidth === "" ? true : x.width === +this.filterWidth) &&
                (this.filterHeight === "" ? true : x.height === +this.filterHeight)
        );
    }

    get filterActive(): boolean {
        return (
            this.searchText !== "" ||
            this.filterWidth !== "" ||
            this.filterHeight !== "");
    }
}
